export default __webpack_public_path__ + "static/pattern-dark-big-d1b05c78a8d8904bb9eeb1584686a7fa.svg";